import { useLocation } from "react-router-dom";
import SoilReport from "@/components/reports/soil/SoilReport";
import PlantReport from "@/components/reports/plant/PlantReport";
import WaterExperiment from "@/components/reports/water/waterExperiment";
import ReportViewer from "@/features/reports/presentation/pages/ReportViewer";
import { PARAMETERS_CATEGORY } from "@/features/laboratory/domain/laboratory.enum";

function LaboratoryReportViewer() {
  const location = useLocation();

  const reportUrl: string = location.state.reportUrl;
  const categoryId: number = location.state.categoryId;

  if (reportUrl) {
    return <ReportViewer />;
  } else {
    if (categoryId === PARAMETERS_CATEGORY.soil) {
      return <SoilReport />;
    } else if (categoryId === PARAMETERS_CATEGORY.plant) {
      return <PlantReport />;
    } else if (categoryId === PARAMETERS_CATEGORY.water) {
      return <WaterExperiment />;
    }
  }
}

export default LaboratoryReportViewer;
